import { Icon } from 'core-ui';
import { Svg } from 'src/assets/icons/MfortIcon/svg';
import { CustomIconComponentProps } from 'src/models/icon';

export const MfortIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
);
